import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import OrderDetails from '../../components/OrderDetails'

function OrderDetailsPage() {
    return (
        <>
            <Helmet>
                <title>Order Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <OrderDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default OrderDetailsPage;

